import { ArrowNarrowDownIcon, ArrowNarrowLeftIcon } from "@heroicons/react/solid";
import BigNumber from "bignumber.js";
import { Component, useEffect, useRef, useState } from "react";
import { useSpring, animated } from '@react-spring/web';
import useMeasure from "react-use-measure";
import { CoinSelector, InformationBar, LoadingDialog } from "../components/CommonComponents";
import { WalletAccount, WAIdToName } from "../conf/Config";
import DataCenter from "../modules/DataCenter";
import { Localize } from "../modules/localize/Localize";
import Button from "../components/control/Button";
import iconExchange from '../images/icon-exchange.svg'
import API from "../conf/API";
import { request } from "../utils/request";
import { ToastType, useToast } from "../components/Toast";

export const TransferView = ({ addView, fireViewAction, currentAccount }) => {
    const waFromId = WalletAccount.GameAccount;
    const waToId = WalletAccount.TradeAccount;

    const [loading, setLoading] = useState(false);
    const [waFrom, setWAFrom] = useState(waFromId);
    const [waTo, setWATo] = useState(waToId);
    const [currCoin, setCurrCoin] = useState(1);
    const [currAmt, setCurrAmt] = useState(new BigNumber(0));
    const input = useRef();

    const [makeToast] = useToast();

    useEffect(
        () => {
            if (currentAccount != null) {
                let t = WalletAccount.TradeAccount;
                const f = currentAccount.walletId == WalletAccount.All ? WalletAccount.GameAccount : currentAccount.walletId;
                if (f == WalletAccount.TradeAccount) {
                    t = WalletAccount.GameAccount;
                }
                setWAFrom(f);
                setWATo(t);
                setCurrAmt(new BigNumber(0));
                input.current.value = "";
            }
        }, [currentAccount]
    )

    let cc = DataCenter.getCoin(currCoin);
    if (cc == null) cc = { name: "" }

    const balance = DataCenter.walletBalance(waFrom, currCoin, false);
    const frozen = DataCenter.walletFrozen(waFrom, currCoin, false);

    const showNEB = balance == 0;
    const btnTransferEnable = (currAmt != 0) && (currAmt.comparedTo(balance) <= 0);

    const doTransfer = () => {
        let params = {
            accountId: DataCenter.accountId,
            from: waFrom,
            to: waTo,
            type: currCoin,
            value: currAmt.toFixed()
        };
        const url = API.wallet_transfer(params);
        setLoading(true);
        request(url).then(ret => {
            DataCenter.updateWalletBalance(ret);
            makeToast("划转成功", ToastType.right);
            setLoading(false);
            fireViewAction({ name: "close" })
        })
    }

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">{
                Localize.getMsg(Localize.COMMON.Transfer)
            }</div>
        </div>
        <div className={"w-full flex flex-1 flex-col  p-4"}>
            <InformationBar text={"本次划转不会产生网络费用"} />
            <TransferAccountPanel
                waFrom={waFrom}
                waTo={waTo}
                onExchangeClicked={() => {
                    setWAFrom(waFrom == WalletAccount.GameAccount ? WalletAccount.TradeAccount : WalletAccount.GameAccount);
                    setWATo(waTo == WalletAccount.GameAccount ? WalletAccount.TradeAccount : WalletAccount.GameAccount);
                }}
            />
            <div className='bg-gray-100 w-full mt-1 mb-1 rounded-lg pl-5 pr-5 pt-2 pb-2 flex flex-col'>
                <CoinSelector onCoinSelected={coin => { setCurrCoin(coin) }} />
            </div>
            <div className='text-m text-red-500' hidden={!showNEB}>当前币种无可划转资产，请选择其他币种</div>

            <div className='text-xl text-gray-500 mt-5'>数量</div>

            <div className='bg-gray-100 w-full mt-2 mb-1 rounded-lg pl-5 pr-5 pt-2 pb-2 flex flex-row items-center'>
                <input ref={input} type="number" className=' bg-gray-100 mt-2 mb-2 flex-1 outline-none' onChange={
                    e => {
                        const v = e.target.value == "" ? "0" : e.target.value;
                        setCurrAmt(new BigNumber(v));
                    }
                } />
                <div className='text-gray-400'>{cc.name.toUpperCase()}</div>
                <div className='text-txt-selected pl-3 pr-3' onClick={() => {
                    input.current.value = balance.toFixed();
                    setCurrAmt(balance);
                }}>最大</div>
            </div>
            <div className='text-m text-red-500' hidden={currAmt.comparedTo(balance) <= 0}>可用资产数量不足</div>
            <div className='w-full flex flex-row'>
                <div className='text-gray-400'>可用资产：</div>
                <div className='flex-1 items-end justify-end flex'>{balance.toFixed(cc.showDecimals)} {cc.name.toUpperCase()}</div>
            </div>
            {
                waFrom == WalletAccount.TradeAccount ?
                    <div className='w-full flex flex-row pt-1'>
                        <div className='text-gray-400'>下单冻结：</div>
                        <div className='flex-1 items-end justify-end flex'>{frozen.toFixed(cc.showDecimals)} {cc.name.toUpperCase()}</div>
                    </div> : <div></div>
            }
        </div>
        <BottomButtons
            move={1}
            btnTransferEnable={btnTransferEnable}
            onClick={btn => {
                if (btn == "transfer") {
                    doTransfer();
                } else if (btn == "back") {
                    //onBackButtonClicked();
                    fireViewAction({ name: "close" })
                }
            }}
        />
        <LoadingDialog show={loading} />
    </div>
}

function BottomButtons({ move, btnTransferEnable, onClick }) {
    const h = move == -1 ? 64 : 0;
    const styles = useSpring({
        to: { height: h },
    })
    return <div className='flex flex-row pt-2'>
        <Button className="text-xl font-semibold h-12" rounded="rounded-l-md"
            widthStyle="flex-1" name="确认划转" type="primary" disabled={!btnTransferEnable} onClicked={e => {
                onClick("transfer");
            }} />
        <Button name="返回" rounded="rounded-r-md" onClicked={e => {
            onClick("back");
        }} />
    </div>
}

class TransferAccountPanel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { waFrom, waTo, onExchangeClicked } = this.props;
        return (
            <div className='bg-gray-100 w-full mt-3 mb-5 rounded-lg p-5 flex flex-row'>
                <div className='pl-5 flex-1 flex flex-col'>
                    <div className='flex'>
                        <div className='text-gray-500'>从</div>
                        <div className='ml-10 text-lg'>
                            {WAIdToName(waFrom)}
                        </div>
                    </div>
                    <div>
                        <ArrowNarrowDownIcon className="mt-2 mb-2 h-4 text-gray-400"
                            aria-hidden="true" />
                    </div>
                    <div className='flex'>
                        <div className='text-gray-500'>到</div>
                        <div className='ml-10 text-lg'>
                            {WAIdToName(waTo)}
                        </div>
                    </div>
                </div>
                <div className='w-8 mr-3 flex flex-row items-center' onClick={e => {
                    onExchangeClicked();
                }}>
                    <img src={iconExchange} />
                </div>
            </div>
        );
    }
}